const common = {
  // Nav
  nav_home: '首页',
  nav_about: '关于我们',
  nav_services: '服务项目',
  nav_cases: '好孕案例',
  nav_knowledge: '行业科普',
  nav_contact: '联系我们',
  nav_consult: '免费咨询',
  nav_switch_lang: '切换语言',
  nav_service_overview: '服务总览',
  nav_service_ivf: '三代试管',
  nav_service_surrogacy: '单助孕',
  nav_service_full: '试管助孕',

  // Hero
  hero_title1: '三代试管 · 单助孕 · 试管助孕',
  hero_title2: '吉尔吉斯斯坦专业生殖中心',
  hero_subtitle: '三大核心服务，灵活方案选择，从促排取卵到宝宝回国，全程专业护航',
  hero_cta1: '免费预约咨询',
  hero_cta2: '了解服务详情',
  hero_stat1: '成功案例',
  hero_stat2: '专业医生',
  hero_stat3: '服务年限',
  hero_stat4: '国际认证',
  hero_prev_slide: '上一张',
  hero_next_slide: '下一张',
  hero_slide_to: '切换到第{{n}}张',

  // Brand
  brand_name: '吉尔吉斯斯坦试管代孕中心',
  brand_sub: '试管代孕中心',

  // Services
  services_title: '专业服务项目',
  services_subtitle: '我们提供吉尔吉斯斯坦辅助生殖全链条服务，从医疗方案到法律保障，全程专业陪伴',
  services_label: 'Our Services',
  service_surrogacy: '单助孕',
  service_surrogacy_desc: '已有胚胎的代孕服务，严格筛选爱心妈妈，全程孕期监护，法律权益保障',
  service_ivf: '三代试管',
  service_ivf_desc: 'PGT-A基因筛查三代试管，单周期8颗胚胎筛查，提高成功率降低流产风险',
  service_egg: '试管助孕',
  service_egg_desc: '试管+代孕全链条服务，从促排取卵到宝宝回国，一站式圆梦方案',
  service_legal: '法律支持',
  service_legal_desc: '吉尔吉斯斯坦合法政策，双亲权保障，出生证明办理',
  service_more: '了解详情',

  // WhyUs
  whyus_label: 'Why Choose Us',
  whyus_title: '为什么选择我们',
  whyus_floating_label: '成功案例，幸福家庭遍布全球',
  whyus_legal: '合法合规保障',
  whyus_legal_desc: '吉尔吉斯斯坦代孕合法，双亲权受法律明确保护',
  whyus_medical: '顶级医疗资源',
  whyus_medical_desc: '与当地顶级生殖医院合作，先进IVF/PGT技术',
  whyus_global: '全球华人服务',
  whyus_global_desc: '中英俄三语专业团队，全程中文陪伴服务',
  whyus_transparent: '透明报价机制',
  whyus_transparent_desc: '无隐藏费用，详细报价清单，全包套餐服务',
  whyus_consultant: '一对一专属顾问',
  whyus_consultant_desc: '从初次咨询到宝宝出生，专属顾问全程跟进',
  whyus_experience: '十年专业经验',
  whyus_experience_desc: '超500个成功案例，积累丰富实战经验',

  // Testimonials
  testimonials_label: 'Testimonials',
  testimonials_title: '客户真实见证',
  testimonial_name1: '赵女士 & 王先生',
  testimonial_loc1: '北京',
  testimonial_content1: '从第一次咨询到宝宝出生，RTB团队全程陪伴，让我们在异国他乡感受到了家的温暖。感谢每一位工作人员，你们帮我们实现了多年的梦想。',
  testimonial_service1: '代孕+试管',
  testimonial_name2: 'Li Family',
  testimonial_loc2: '上海',
  testimonial_content2: '试管多次失败后几乎绝望，在朋友推荐下找到了RTB。顾问非常耐心地帮我们分析情况，制定了三代试管方案，第一次移植就成功了！',
  testimonial_service2: '三代试管',
  testimonial_name3: 'Марина К.',
  testimonial_loc3: 'Москва',
  testimonial_content3: 'Команда RTB оказалась очень профессиональной и заботливой. Весь процесс прошел гладко, и сейчас у нас есть наш долгожданный малыш.',
  testimonial_service3: 'ЭКО + Суррогатное',

  // Cases
  cases_title: '好孕案例',
  cases_subtitle: '每一个宝贝都是奇迹，这里有真实家庭的幸福分享',
  cases_view_all: '查看全部案例',
  cases_share: '分享案例',
  cases_share_modal_title: '分享案例',
  cases_share_modal_desc: '传播爱与希望，让更多家庭了解我们',
  cases_cat_all: '全部案例',
  cases_cat_surrogacy: '单代孕',
  cases_cat_ivf: '三代试管',
  cases_cat_full: '试管+代孕',
  cases_filter_desc: '按服务类型查看真实家庭的幸福分享',
  cases_no_data: '该分类暂无案例，请选择其他分类',
  cases_stats_stories: '成功案例',
  cases_stats_countries: '服务国家',
  cases_stats_satisfaction: '委托方满意度',
  cases_stats_years: '专业积累',
  cases_cta_title: '您的幸福故事，从这里开始',
  cases_cta_desc: '立即预约免费咨询，迈出圆梦的第一步',
  cases_page_sub: '真实家庭的幸福分享',
  cases_section_label: 'Success Stories',

  // Knowledge
  knowledge_title: '行业科普',
  knowledge_subtitle: '专业医学知识，解答您的每一个疑问',
  knowledge_view_all: '查看全部文章',
  knowledge_cat_all: '全部',
  knowledge_cat_guide: '干货科普',
  knowledge_cat_medical: '医学知识',
  knowledge_cat_faq: '常见问题',
  knowledge_cat_legal: '法律政策',
  knowledge_read_full: '阅读全文',
  knowledge_related_title: '相关文章推荐',
  knowledge_more_title: '更多文章',
  knowledge_share: '分享：',
  knowledge_not_found: '文章未找到',
  knowledge_back: '返回行业科普',
  knowledge_loading: '加载中...',
  knowledge_loading_articles: '加载文章中...',
  knowledge_no_articles: '暂无相关文章',
  knowledge_sidebar_tags: '热门标签',
  knowledge_sidebar_stats: '分类统计',
  knowledge_sidebar_cta: '还有疑问？立即咨询',
  knowledge_sidebar_cta_desc: '专业顾问免费解答，24小时响应您的每个问题',
  knowledge_sidebar_cta_btn: '免费预约咨询',
  knowledge_tag_articles: '篇文章',
  knowledge_tag_related: '与"{{tag}}"相关的所有文章',
  knowledge_tag_view_all: '查看全部文章',
  knowledge_section_label: 'Knowledge Center',
  knowledge_filter_placeholder: '搜索文章...',
  knowledge_current_tag_filter: '当前标签筛选：',
  knowledge_clear_filter: '清除筛选',

  // FAQ
  faq_title: '常见问题',
  faq_subtitle: '我们整理了最常见的问题，帮助您快速了解',
  faq_label: 'FAQ',
  faq_cat_all: '全部',
  faq_cat_process: '流程',
  faq_cat_medical: '医疗',
  faq_cat_legal: '法律',
  faq_cat_cost: '费用',
  faq_no_data: '暂无常见问题',
  faq_load_error: '加载失败，请检查网络后重试',

  // Appointment
  appt_title: '预约免费咨询',
  appt_subtitle: '填写以下信息，我们的专业顾问将在24小时内与您联系',
  appt_name: '您的姓名',
  appt_phone: '联系电话',
  appt_wechat: '微信号',
  appt_email: '电子邮箱',
  appt_service: '咨询服务',
  appt_message: '补充说明',
  appt_submit: '立即预约',
  appt_success: '预约成功！我们将尽快与您联系。',
  appt_service_opt1: '单助孕',
  appt_service_opt2: '三代试管',
  appt_service_opt3: '试管助孕',
  appt_service_opt4: '综合咨询',
  appt_label: 'Free Consultation',
  appt_form_title: '预约免费咨询',
  appt_form_desc: '填写信息，专属顾问24小时内联系您',
  appt_form_privacy: '严格保护隐私',
  appt_form_wechat_hint: '也可添加微信：16600032397',
  appt_form_name_placeholder: '请输入您的姓名',
  appt_form_phone_placeholder: '+86 或境外号码',
  appt_form_wechat_placeholder: '微信号（可选）',
  appt_form_email_placeholder: 'email@example.com（可选）',
  appt_form_service_placeholder: '请选择咨询服务',
  appt_form_message_placeholder: '请描述您的具体情况或需求（年龄、已有检查结果、是否做过试管等），最多500字',
  appt_form_contact_soon: '我们将在24小时内与您联系，请保持电话畅通',

  // Contact
  contact_title: '联系我们',
  contact_subtitle: '随时欢迎您与我们取得联系',
  contact_phone: '联系电话',
  contact_wechat: '微信咨询',
  contact_email: '电子邮箱',
  contact_address: '办公地址',
  contact_scan_wechat: '扫码添加微信',
  contact_scan_whatsapp: '扫码WhatsApp',
  contact_online: '在线咨询',
  contact_label: 'Contact Us',
  contact_info_title: '联系方式',
  contact_qr_title: '扫码咨询',
  contact_wechat_click: '（点击查看二维码）',
  contact_form_title: '在线预约咨询',
  contact_form_desc: '填写以下信息，顾问将在24小时内与您联系',
  contact_form_privacy: '我们承诺保护您的隐私信息安全',
  contact_map_title: '办公室位置',
  contact_map_title_attr: '吉尔吉斯斯坦比什凯克办公室位置',

  // CTA Banner
  cta_label: 'Free Consultation · 免费咨询',
  cta_title1: '开启您的好孕之旅',
  cta_title2: '专属顾问 24 小时内回复',
  cta_desc: '无论您身处何地，我们的专业中文团队随时待命。从首次咨询到宝宝出生，每一步都有人陪伴。',
  cta_btn1: '免费预约咨询',
  cta_btn2: '查看成功案例',
  cta_badge1: '合法代孕保障',
  cta_badge2: '严格隐私保护',
  cta_badge3: '中英俄三语服务',
  cta_badge4: '一对一专属顾问',

  // Footer
  footer_rights: '© 2026 吉尔吉斯斯坦试管代孕中心. 保留所有权利.',
  footer_privacy: '隐私政策',
  footer_terms: '服务条款',
  footer_desc: '专业的吉尔吉斯斯坦试管代孕服务，为您的幸福家庭之路保驾护航。',
  footer_quick_links: '快速导航',
  footer_contact: '联系方式',
  footer_scan: '扫码联系我们',
  footer_phone: '+86 16600032397',
  footer_email: 'ivfjason@gmail.com',
  footer_address: '吉尔吉斯斯坦·比什凯克',
  footer_wechat_label: '微信咨询',
  footer_whatsapp_label: 'WhatsApp',

  // About
  about_title: '关于我们',
  about_subtitle: '十年深耕，只为每个家庭的圆梦之路',
  about_desc1: '吉尔吉斯斯坦试管代孕中心成立于2014年，是专注于中亚地区辅助生殖服务的专业机构。我们拥有顶级医疗资源与完善的法律体系，为来自全球的准父母提供安全、合法、高效的生育解决方案。',
  about_desc2: '吉尔吉斯斯坦相关法律明确保护委托方的双亲权利，是全球少数对代孕持开放态度并有完整法律框架保护的国家之一。',
  about_mission: '我们的使命',
  about_mission_desc: '让每一个渴望孩子的家庭都能实现梦想，用专业和爱心守护每一段生命的诞生。',

  // Services page
  svc_intro: '我们提供吉尔吉斯斯坦辅助生殖全链条服务，从医疗方案到法律保障，全程专业陪伴',
  svc_ivf_title: '三代试管',
  svc_ivf_subtitle: 'PGT-A 第三代试管婴儿',
  svc_ivf_desc: '单周期三代试管套餐，包含生殖学专家远程及本地见诊、联合两地促排、取卵、ICSI单精子注射、全部胚胎体外培养5-7天、全部胚胎活检、单周期PGT-A筛查（含8颗胚胎）、单周期内一次胚胎移植、1年期胚胎冷冻保存。',
  svc_surrogacy_title: '单助孕',
  svc_surrogacy_subtitle: '已有胚胎的代孕服务',
  svc_surrogacy_desc: '已有胚胎的准父母专属代孕服务。包含助孕志愿者筛选与必要检查、血检妊娠测试、每月孕期检查、志愿者生活补偿、1年期胚胎冷冻保存、全程孕检报告解读、持牌妇产医院顺产、协助办理出生医学证明、DNA亲子鉴定、新生儿回国手续及签证。',
  svc_full_title: '试管助孕',
  svc_full_subtitle: '试管+代孕全链条服务',
  svc_full_desc: '从促排取卵到宝宝回国的一站式全链条服务。惠享/安心/无忧三档方案可选，分别适合不同需求与预算的准父母家庭。',
  svc_cta_title: '不确定哪种方案适合您？',
  svc_cta_desc: '联系我们的专业顾问，免费获取个性化服务方案建议',
  svc_section_label: 'Services',
  svc_ivf_feature1: '远程+本地专家见诊',
  svc_ivf_feature2: '联合两地促排方案',
  svc_ivf_feature3: 'ICSI单精子注射',
  svc_ivf_feature4: '全部胚胎活检+PGT-A',
  svc_ivf_feature5: '8颗胚胎基因筛查',
  svc_ivf_feature6: '1年期胚胎冷冻保存',
  svc_surrogacy_feature1: '志愿者严格筛选',
  svc_surrogacy_feature2: '全程孕期监护',
  svc_surrogacy_feature3: '持牌妇产医院顺产',
  svc_surrogacy_feature4: 'DNA亲子鉴定',
  svc_surrogacy_feature5: '出生证明+回国签证',
  svc_surrogacy_feature6: '海牙公证协助',
  svc_full_feature1: '三代试管+代孕全流程',
  svc_full_feature2: '三档方案灵活选择',
  svc_full_feature3: '不限次胚胎移植（安心/无忧）',
  svc_full_feature4: '多周期促排保障（无忧）',
  svc_full_feature5: '孕期风险补偿',
  svc_full_feature6: '一站式回国证件办理',

  // IVF detail page
  ivf_breadcrumb_svc: '服务项目',
  ivf_breadcrumb: '三代试管（PGT-A）',
  ivf_label: 'Third-Generation IVF',
  ivf_page_title: '三代试管（PGT-A）',
  ivf_hero_desc: '单周期三代试管套餐，包含全部胚胎培养、活检及PGT-A基因筛查（8颗胚胎），ICSI单精子注射，1年期胚胎冷冻保存。',
  ivf_cta_consult: '免费预约咨询',
  ivf_cta_whatsapp: 'WhatsApp咨询',
  ivf_stat_price: '单周期套餐费用',
  ivf_stat_screen: 'PGT-A胚胎筛查',
  ivf_stat_rate: '35岁以下成功率',
  ivf_stat_freeze: '胚胎冷冻保存期',
  ivf_process_title: '三代试管完整流程',
  ivf_process_sub: '八大步骤，全程专业医疗团队保驾护航',
  ivf_process_label: 'IVF Complete Process',
  ivf_included_title: '套餐包含项目',
  ivf_included_sub: '单周期三代试管$19,000套餐详细内容',
  ivf_extra_title: '套餐外按需及可能产生的费用',
  ivf_extra_sub: '以下为常见额外费用项目，实际按需产生',
  ivf_cta_title: '开启您的三代试管之旅',
  ivf_cta_desc: '专业医疗顾问免费解答，为您制定最适合的试管方案',

  // IVF steps
  ivf_step1_title: '方案制定与评估',
  ivf_step1_dur: '第1-2周',
  ivf_step1_desc: '生殖学专家远程面诊及本地见诊，对双方进行全面的生育功能评估。包括卵巢储备（AMH/AFC）、精液分析、子宫形态评估、染色体核型检查等，制定个性化IVF方案。',
  ivf_step1_p1: '远程+本地专家见诊',
  ivf_step1_p2: '卵巢储备AMH/AFC检测',
  ivf_step1_p3: '精液常规及形态分析',
  ivf_step1_p4: '染色体核型检查',
  ivf_step2_title: '控制性促排卵',
  ivf_step2_dur: '第2-4周',
  ivf_step2_desc: '联合两地见诊促排，根据个人情况选择适合的促排方案。通过每日注射促性腺激素刺激多个卵泡同步发育，期间密切监测卵泡生长。促排药物费用未含国内部分。',
  ivf_step2_p1: '个性化促排方案选择',
  ivf_step2_p2: '连续B超卵泡监测',
  ivf_step2_p3: '激素水平动态检测',
  ivf_step2_p4: '及时方案调整优化',
  ivf_step3_title: '取卵手术',
  ivf_step3_dur: '第4-5周',
  ivf_step3_desc: '当主导卵泡发育至成熟（18-22mm），注射HCG扳机36小时后，在静脉麻醉下经阴道B超引导取卵，全程约20-30分钟。如不适合经阴道取卵，可采用腹部取卵方案。',
  ivf_step3_p1: '静脉麻醉无痛取卵',
  ivf_step3_p2: 'B超精准引导',
  ivf_step3_p3: '高经验医生操作',
  ivf_step3_p4: '取卵后当日可休息恢复',
  ivf_step4_title: '精液优化与ICSI',
  ivf_step4_dur: '取卵同日',
  ivf_step4_desc: '取卵当日同步采集精液，经密度梯度离心处理，筛选出最优质精子。采用ICSI单精子注射技术，直接将单个精子注入卵母细胞。',
  ivf_step4_p1: '密度梯度精子优选',
  ivf_step4_p2: 'ICSI单精子注射',
  ivf_step4_p3: '精子活力形态评估',
  ivf_step4_p4: '冷冻精液备用方案',
  ivf_step5_title: '体外受精与胚胎培养',
  ivf_step5_dur: '第5-10天',
  ivf_step5_desc: '受精卵在恒温全时培养箱中培育5-7天至囊胚阶段。实验室采用延时摄影动态监控系统，实时记录胚胎发育过程。',
  ivf_step5_p1: '先进培养液体系',
  ivf_step5_p2: '延时摄影动态监控',
  ivf_step5_p3: '全部胚胎培养至囊胚',
  ivf_step5_p4: 'Gardner评分体系评估',
  ivf_step6_title: 'PGT-A基因筛查',
  ivf_step6_dur: '第10-30天',
  ivf_step6_desc: '对全部囊胚进行活检，通过PGT-A技术筛查胚胎染色体整倍体。套餐含8颗胚胎PGT-A筛查，额外胚胎$550/颗。',
  ivf_step6_p1: '全部胚胎活检',
  ivf_step6_p2: 'PGT-A染色体整倍体筛查',
  ivf_step6_p3: '套餐含8颗胚胎筛查',
  ivf_step6_p4: 'PGT-M单基因病筛查可选',
  ivf_step7_title: '胚胎移植',
  ivf_step7_dur: '月经第2-5周期',
  ivf_step7_desc: '选择最优质胚胎，在B超引导下通过细软导管经宫颈植入子宫腔。单周期内包含一次胚胎移植，全程无需麻醉，约5-10分钟。',
  ivf_step7_p1: '无创软导管移植',
  ivf_step7_p2: 'B超实时引导定位',
  ivf_step7_p3: '单周期一次移植',
  ivf_step7_p4: '14天后血HCG验孕',
  ivf_step8_title: '验孕与早孕监测',
  ivf_step8_dur: '移植后2-8周',
  ivf_step8_desc: '移植后14天抽血检测HCG确认妊娠。确认妊娠后持续监测HCG和孕酮水平，移植后5-6周行B超确认宫内孕及胎心。',
  ivf_step8_p1: '血HCG精确验孕',
  ivf_step8_p2: 'B超确认宫内孕及胎心',
  ivf_step8_p3: '黄体支持方案调整',
  ivf_step8_p4: '早孕密切随访',

  // IVF included items
  ivf_item1_title: '生殖学专家见诊',
  ivf_item1_desc: '远程面诊及本地见诊，联合两地促排方案制定，未含额外见诊方案费。',
  ivf_item2_title: '全时培养箱动态监测',
  ivf_item2_desc: '先进延时摄影培养箱，24小时不间断监控胚胎发育过程，精准评估胚胎质量。',
  ivf_item3_title: '检查报告评估',
  ivf_item3_desc: '周期前双方必要检查项目评估，制定个性化促排及移植方案。',
  ivf_item4_title: '促排与取卵',
  ivf_item4_desc: '各含1次促排与取卵，静脉麻醉无痛取卵，B超精准引导。',
  ivf_item5_title: 'ICSI单精子注射',
  ivf_item5_desc: '显微操作将单个优质精子直接注入卵母细胞，提高受精率。',
  ivf_item6_title: '全部胚胎体外培养',
  ivf_item6_desc: '全部胚胎培养5-7天至囊胚阶段，采用先进培养液体系。',
  ivf_item7_title: '全部胚胎活检',
  ivf_item7_desc: '对全部囊胚进行滋养层细胞活检，为PGT-A筛查提供样本。',
  ivf_item8_title: 'PGT-A筛查（8颗）',
  ivf_item8_desc: '单周期8颗胚胎PGT-A染色体整倍体筛查，超出按$550/颗。',
  ivf_item9_title: '1次胚胎移植',
  ivf_item9_desc: '单周期内一次胚胎移植，B超引导无创软导管精准植入。',
  ivf_item10_title: '1年期胚胎冷冻',
  ivf_item10_desc: '剩余胚胎玻璃化冷冻保存1年，存活率99%以上。',
  ivf_item11_title: '吉国本地服务',
  ivf_item11_desc: '地接医疗翻译陪同、机场接送机（一次往返）、医院附近酒店医疗用车。',
  ivf_item12_title: '生活配套',
  ivf_item12_desc: '电话卡2张、充电转换插头1个，协助预定公寓及酒店。',

  // IVF extra costs
  ivf_extra1_title: '腹部取卵',
  ivf_extra1_price: '待定',
  ivf_extra1_desc: '不适合经阴道取卵时采用',
  ivf_extra2_title: '额外胚胎PGT-A',
  ivf_extra2_price: '$550/颗',
  ivf_extra2_desc: '套餐含8颗，超出部分',
  ivf_extra3_title: '胚胎PGT-M筛查',
  ivf_extra3_price: '$800/颗',
  ivf_extra3_desc: '单基因遗传病筛查',
  ivf_extra4_title: '二次促排含药',
  ivf_extra4_price: '$14,000/次',
  ivf_extra4_desc: '含8颗PGT-A筛查',
  ivf_extra5_title: '供精/卵志愿者',
  ivf_extra5_price: '按需',
  ivf_extra5_desc: '吉哈俄白台乌等',
  ivf_extra6_title: '精子生化分离',
  ivf_extra6_price: '$700',
  ivf_extra6_desc: '额外冻精操作',
  ivf_extra7_title: '睾丸穿刺',
  ivf_extra7_price: '待定',
  ivf_extra7_desc: '取精困难时采用',
  ivf_extra8_title: '电子签证',
  ivf_extra8_price: '时价',
  ivf_extra8_desc: '吉尔吉斯斯坦电子签证',
  ivf_extra9_title: '吉国往返机票',
  ivf_extra9_price: '实报实销',
  ivf_extra9_desc: '时价波动',
  ivf_extra10_title: '国内促排上门打针',
  ivf_extra10_price: '自理',
  ivf_extra10_desc: '促排期间上门打针',
  ivf_extra11_title: '移植后上门打针',
  ivf_extra11_price: '自理',
  ivf_extra11_desc: '移植后黄体支持',
  ivf_extra12_title: '验孕后保胎药物',
  ivf_extra12_price: '自理',
  ivf_extra12_desc: '保胎用药费用',

  // Surrogacy detail page
  scy_breadcrumb: '单助孕',
  scy_label: 'Single Surrogacy',
  scy_page_title: '单助孕',
  scy_hero_desc: '已有胚胎的准父母专属代孕服务。从志愿者筛选到宝宝回国，全程专业护航。',
  scy_stat_price1: '惠享方案起',
  scy_stat_price2: '安心方案起',
  scy_stat_cases: '成功代孕案例',
  scy_stat_legal: '合法双亲权保障',
  scy_process_title: '单助孕完整流程',
  scy_process_sub: '从初次咨询到宝宝回国，全程透明，每步专业陪伴',
  scy_process_label: 'Complete Process',
  scy_included_title: '套餐包含项目',
  scy_included_sub: '单助孕套餐详细内容（安心/惠享两档方案）',
  scy_extra_title: '套餐外按需及可能产生的费用',
  scy_extra_sub: '以下为常见额外费用项目，实际按需产生',
  scy_plan_title: '单助孕方案对比',
  scy_plan_sub: '根据您的需求和预算选择最适合的方案',
  scy_plan_label: 'Pricing Plans',
  scy_plan_note_title: '费用说明与包含项目',
  scy_plan_inc_title: '费用通常包含：',
  scy_plan_extra_title: '可能额外费用：',
  scy_plan_note: '* 以上为参考区间，实际费用因方案选择、个人情况及币率变动而有所差异。请联系我们的医疗顾问获取针对您的精确报价。',
  scy_plan_economy: '惠享方案',
  scy_plan_economy_badge: '经济之选',
  scy_plan_economy_desc: '适合预算有限、流程顺利的准父母',
  scy_plan_premium: '安心方案',
  scy_plan_premium_badge: '最受欢迎',
  scy_plan_premium_desc: '含孕期风险补偿，付款更分散，压力更小',
  scy_plan_btn: '获取详细报价',
  scy_cta_title: '准备好开始您的圆梦之旅了吗？',
  scy_cta_desc: '预约免费咨询，专属顾问为您详细解答所有疑问并制定个性化方案',

  // Surrogacy steps
  scy_step1_title: '免费初步咨询',
  scy_step1_dur: '第1-2周',
  scy_step1_desc: '联系RTB专业顾问，进行免费的初次视频或电话咨询。顾问详细了解您的需求、已有胚胎情况、预算等，为您推荐最适合的代孕方案（安心或惠享）。',
  scy_step1_p1: '专属顾问一对一服务',
  scy_step1_p2: '已有胚胎情况评估',
  scy_step1_p3: '方案与费用透明说明',
  scy_step1_p4: '签订服务协议',
  scy_step2_title: '助孕志愿者筛选',
  scy_step2_dur: '第1-3个月',
  scy_step2_desc: '从经过严格健康筛查的助孕志愿者数据库中进行匹配。志愿者需通过三重健康筛查认证、心理健康评估，您可以查看候选人的健康档案并确认匹配。',
  scy_step2_p1: '数百名候选志愿者',
  scy_step2_p2: '三重健康筛查认证',
  scy_step2_p3: '心理健康评估',
  scy_step2_p4: '特征背景综合匹配',
  scy_step3_title: '医疗检查与准备',
  scy_step3_dur: '第2-4周',
  scy_step3_desc: '志愿者进行全面的健康检查，包括血检、传染病检测、妇科检查等。同时评估您提供的胚胎质量，确定移植方案和时间安排。',
  scy_step3_p1: '志愿者全面健康检查',
  scy_step3_p2: '血检及传染病检测',
  scy_step3_p3: '胚胎质量评估',
  scy_step3_p4: '移植方案制定',
  scy_step4_title: '胚胎移植',
  scy_step4_dur: '第3-4个月',
  scy_step4_desc: '选择最优质的胚胎，在B超引导下通过细软导管移植至志愿者子宫内。单助孕套餐包含一次移植。移植后14天进行血检确认妊娠。',
  scy_step4_p1: 'B超引导精准移植',
  scy_step4_p2: '一次胚胎移植',
  scy_step4_p3: '14天血检验孕',
  scy_step4_p4: '黄体支持方案',
  scy_step5_title: '孕期全程监护',
  scy_step5_dur: '第4-9个月',
  scy_step5_desc: '整个孕期，我们的专业医疗团队全程监护志愿者的健康状况，每月进行必要产检，实时同步孕情报告，协调视频通话，让您随时了解宝宝成长。',
  scy_step5_p1: '每月产检报告同步',
  scy_step5_p2: '24小时医疗支持',
  scy_step5_p3: '志愿者生活补偿',
  scy_step5_p4: '营养与心理关怀',
  scy_step6_title: '孩子出生',
  scy_step6_dur: '预产期前后',
  scy_step6_desc: '宝宝在持牌妇产医院顺产出生。生产过程志愿者专属陪同，专业新生儿护理。医院直接协助办理产后院内相关文件，出生证明上登记委托方为法定父母。',
  scy_step6_p1: '持牌妇产医院顺产',
  scy_step6_p2: '委托方直接登记为父母',
  scy_step6_p3: '专业新生儿护理',
  scy_step6_p4: '出生全程陪同服务',
  scy_step7_title: '证件办理与回国',
  scy_step7_dur: '出生后1-2个月',
  scy_step7_desc: '协助办理婴儿与准父母的DNA亲子鉴定、新生儿出生医学证明、海牙公证、回国签证及旅行证等全套手续，确保您顺利带宝宝回国。',
  scy_step7_p1: 'DNA亲子鉴定',
  scy_step7_p2: '出生证明+海牙公证',
  scy_step7_p3: '中国护照/签证申请',
  scy_step7_p4: '回国手续全程支持',
  // Surrogacy included items
  scy_item1_title: '志愿者筛选与检查',
  scy_item1_desc: '严格筛选与必要健康检查，三重筛查认证，确保志愿者身心健康。',
  scy_item2_title: '血检妊娠测试',
  scy_item2_desc: '敏感血检确认妊娠，移植后14天精准验孕，确保结果可靠。',
  scy_item3_title: '每月必要孕期检查',
  scy_item3_desc: '志愿者每月必要产检，全程孕检报告解读与评估，医疗团队24小时响应。',
  scy_item4_title: '志愿者生活补偿',
  scy_item4_desc: '含志愿者服装、生活、营养费及生活补偿，保障志愿者孕期生活质量。',
  scy_item5_title: '1年期胚胎冷冻',
  scy_item5_desc: '剩余胚胎玻璃化冷冻保存1年，存活率99%以上，可随时解冻移植。',
  scy_item6_title: '协调视频通话',
  scy_item6_desc: '协调与志愿者视频通话，让您随时了解宝宝成长状态，沟通无障碍。',
  scy_item7_title: '生产过程专属陪同',
  scy_item7_desc: '生产过程志愿者专属陪同，持牌妇产医院顺产，专业新生儿护理。',
  scy_item8_title: '出生医学证明',
  scy_item8_desc: '协助办理新生儿出生后医学证明，委托方直接登记为法定父母。',
  scy_item9_title: 'DNA亲子鉴定',
  scy_item9_desc: '协助提供婴儿与准父母DNA亲子鉴定，为回国手续提供法律依据。',
  scy_item10_title: '新生儿回国手续',
  scy_item10_desc: '协助办理新生儿回国签证、旅行证等全套手续，确保顺利回国。',
  scy_item11_title: '吉国本地服务',
  scy_item11_desc: '地接医疗翻译陪同、机场接送机（一次往返）、医院附近酒店医疗用车。',
  scy_item12_title: '生活配套',
  scy_item12_desc: '电话卡2张、充电转换插头1个，协助预定公寓及酒店。',
  // Surrogacy extra costs
  scy_extra1_title: '二次移植手术',
  scy_extra1_price: '$3,000',
  scy_extra1_desc: '含检查、用药，首次未成功时',
  scy_extra2_title: '更换志愿者',
  scy_extra2_price: '$4,000/次',
  scy_extra2_desc: '特殊情况下更换代孕志愿者',
  scy_extra3_title: '胚胎转运费',
  scy_extra3_price: '$12,000/次',
  scy_extra3_desc: '跨国胚胎转运操作费用',
  scy_extra4_title: '双胎妊娠补偿',
  scy_extra4_price: '$12,000',
  scy_extra4_desc: '验孕及出生双胎额外补偿',
  scy_extra5_title: '自然分裂双胎',
  scy_extra5_price: '$12,000',
  scy_extra5_desc: '胚胎自然分裂为双胎的补偿',
  scy_extra6_title: '剖腹产额外',
  scy_extra6_price: '$4,000/次',
  scy_extra6_desc: '剖宫产手术额外补偿',
  scy_extra7_title: '电子签证',
  scy_extra7_price: '时价',
  scy_extra7_desc: '吉尔吉斯斯坦电子签证',
  scy_extra8_title: '吉国往返机票',
  scy_extra8_price: '时价',
  scy_extra8_desc: '往返机票实报实销',
  scy_extra9_title: '孕期保胎费',
  scy_extra9_price: '实报实销',
  scy_extra9_desc: '孕期保胎用药及治疗',
  scy_extra10_title: '早产保温箱',
  scy_extra10_price: '不同医院',
  scy_extra10_desc: '新生儿早产保温箱费用',
  scy_extra11_title: '保姆/育儿嫂',
  scy_extra11_price: '~$1,500/月',
  scy_extra11_desc: '雇佣保姆或育儿嫂费用',
  scy_extra12_title: '海牙认证公证',
  scy_extra12_price: '实报实销',
  scy_extra12_desc: '海牙认证及公证处费用',
  // Surrogacy plan items
  scy_plan_economy_item1: '志愿者筛选与必要检查',
  scy_plan_economy_item2: '血检妊娠测试',
  scy_plan_economy_item3: '每月必要孕期检查',
  scy_plan_economy_item4: '志愿者生活补偿',
  scy_plan_economy_item5: '1年期胚胎冷冻保存',
  scy_plan_economy_item6: '持牌妇产医院顺产',
  scy_plan_economy_item7: '出生医学证明办理',
  scy_plan_economy_item8: 'DNA亲子鉴定协助',
  scy_plan_economy_item9: '新生儿回国手续协助',
  scy_plan_economy_item10: '海牙公证全程协助',
  scy_plan_economy_item11: '地接翻译+机场接送',
  scy_plan_premium_item1: '包含惠享方案全部内容',
  scy_plan_premium_item2: '志愿者孕期风险补偿',
  scy_plan_premium_item3: '生产过程专属陪同',
  scy_plan_premium_item4: '全程孕检报告解读',
  scy_plan_premium_item5: '协助产后院内文件',
  scy_plan_premium_item6: '新生儿回国签证协助',
  scy_plan_premium_item7: '付款节点更分散',
  scy_plan_premium_item8: '单次付款压力更小',
  scy_plan_premium_item9: 'VIP医疗顾问服务',
  scy_plan_premium_item10: '孕期心理支持服务',
  scy_plan_premium_item11: '紧急医疗预案保障',
  // Surrogacy plan note items
  scy_plan_inc_item1: '志愿者健康筛查及管理费',
  scy_plan_inc_item2: '一次胚胎移植医疗费',
  scy_plan_inc_item3: '孕期全程医疗监护',
  scy_plan_inc_item4: '持牌妇产医院顺产费用',
  scy_plan_inc_item5: '出生证明法律文件办理',
  scy_plan_inc_item6: 'DNA亲子鉴定协助',
  scy_plan_inc_item7: '中文顾问全程服务',
  scy_plan_extra_item1: '委托方赴吉国机票及住宿费',
  scy_plan_extra_item2: '中国护照申请及户籍登记费',
  scy_plan_extra_item3: '二次移植手术费',
  scy_plan_extra_item4: '孕期保胎费',
  scy_plan_extra_item5: '保姆育儿嫂费用',
  scy_plan_extra_item6: '双胎妊娠额外补偿',

  // Full service detail page
  full_breadcrumb: '试管助孕',
  full_label: 'IVF + Surrogacy',
  full_page_title: '试管助孕',
  full_hero_desc: '从促排取卵到宝宝回国的一站式全链条服务。惠享/安心/无忧三档方案可选，三代试管+代孕全流程。',
  full_stat_price: '惠享方案起',
  full_stat_plans: '方案灵活选择',
  full_stat_steps: '全流程服务',
  full_stat_legal: '合法双亲权保障',
  full_process_title: '试管助孕完整流程',
  full_process_sub: '从促排取卵到宝宝回国，一站式全链条服务',
  full_process_label: 'Complete Process',
  full_cta_title: '开启您的试管助孕之旅',
  full_cta_desc: '专业医疗顾问免费解答，为您推荐最适合的试管助孕方案',
  // Fertility steps
  full_step1_title: '方案制定与评估',
  full_step1_dur: '第1-2周',
  full_step1_desc: '生殖学专家远程面诊，对双方进行全面的生育功能评估。包括卵巢储备（AMH/AFC）、精液分析、子宫形态评估、染色体核型检查等，制定个性化试管助孕方案。',
  full_step1_p1: '远程+本地专家见诊',
  full_step1_p2: '卵巢储备AMH/AFC检测',
  full_step1_p3: '精液常规及形态分析',
  full_step1_p4: '染色体核型检查',
  full_step2_title: '控制性促排卵',
  full_step2_dur: '第2-4周',
  full_step2_desc: '联合两地见诊促排，根据个人情况选择适合的促排方案。通过每日注射促性腺激素刺激多个卵泡同步发育，期间密切监测卵泡生长。',
  full_step2_p1: '个性化促排方案',
  full_step2_p2: '连续B超卵泡监测',
  full_step2_p3: '激素水平动态检测',
  full_step2_p4: '及时方案调整优化',
  full_step3_title: '取卵手术',
  full_step3_dur: '第4-5周',
  full_step3_desc: '当主导卵泡成熟后，在静脉麻醉下经阴道B超引导取卵，全程约20-30分钟。如不适合经阴道取卵，可采用腹部取卵方案。',
  full_step3_p1: '静脉麻醉无痛取卵',
  full_step3_p2: 'B超精准引导',
  full_step3_p3: '高经验医生操作',
  full_step3_p4: '取卵后当日可休息',
  full_step4_title: 'ICSI与胚胎培养',
  full_step4_dur: '第5-10天',
  full_step4_desc: '采用ICSI单精子注射技术，将单个优质精子注入卵母细胞。受精卵在恒温培养箱中培育5-7天至囊胚阶段，采用延时摄影动态监控胚胎发育。',
  full_step4_p1: 'ICSI单精子注射',
  full_step4_p2: '全部胚胎培养至囊胚',
  full_step4_p3: '延时摄影动态监控',
  full_step4_p4: 'Gardner评分体系',
  full_step5_title: 'PGT-A基因筛查',
  full_step5_dur: '第10-30天',
  full_step5_desc: '对全部囊胚进行活检，通过PGT-A技术筛查染色体整倍体。惠享/安心方案含单次8颗胚胎筛查，无忧方案含多周期PGT-A筛查。',
  full_step5_p1: '全部胚胎活检',
  full_step5_p2: 'PGT-A染色体筛查',
  full_step5_p3: '8颗胚胎套餐内含',
  full_step5_p4: 'PGT-M可选',
  full_step6_title: '胚胎移植',
  full_step6_dur: '第11-14周',
  full_step6_desc: '选择最优质胚胎移植至助孕志愿者子宫内。惠享方案含一次移植，安心/无忧方案含不限次移植。移植后14天血检验孕。',
  full_step6_p1: 'B超引导精准移植',
  full_step6_p2: '惠享1次/安心无忧不限次',
  full_step6_p3: '14天血HCG验孕',
  full_step6_p4: '黄体支持方案',
  full_step7_title: '孕期全程监护',
  full_step7_dur: '第15-40周',
  full_step7_desc: '整个孕期专业医疗团队全程监护志愿者健康状况，每月必要产检，实时同步孕情报告，协调视频通话，提供孕期风险补偿。',
  full_step7_p1: '每月产检报告同步',
  full_step7_p2: '志愿者生活补偿',
  full_step7_p3: '孕期风险补偿',
  full_step7_p4: '24小时医疗支持',
  full_step8_title: '孩子出生',
  full_step8_dur: '预产期前后',
  full_step8_desc: '宝宝在持牌妇产医院顺产出生，生产过程专属陪同。委托方直接登记为法定父母，协助办理产后院内文件及出生医学证明。',
  full_step8_p1: '持牌妇产医院顺产',
  full_step8_p2: '委托方直接登记为父母',
  full_step8_p3: '专业新生儿护理',
  full_step8_p4: '出生全程陪同',
  full_step9_title: '证件办理与回国',
  full_step9_dur: '出生后1-2个月',
  full_step9_desc: '协助办理DNA亲子鉴定、海牙公证、新生儿回国签证、旅行证等全套手续，确保您顺利带宝宝回国。',
  full_step9_p1: 'DNA亲子鉴定',
  full_step9_p2: '出生证明+海牙公证',
  full_step9_p3: '回国签证/旅行证',
  full_step9_p4: '回国手续全程支持',
  // Fertility pricing
  full_plan_economy: '惠享方案',
  full_plan_economy_badge: '经济之选',
  full_plan_economy_desc: '一次促排一次移植，完全顺利情况下的最优选择',
  full_plan_premium: '安心方案',
  full_plan_premium_badge: '最受欢迎',
  full_plan_premium_desc: '一次促排不限次移植，孕期风险补偿，适合年轻客户',
  full_plan_comprehensive: '无忧方案',
  full_plan_comprehensive_badge: '全面保障',
  full_plan_comprehensive_desc: '不限次促排不限次移植，适合需要多次促排的客户',
  full_plan_btn: '获取详细报价',
  full_plan_section_label: 'Pricing Plans',
  full_plan_section_title: '试管助孕方案对比',
  full_plan_section_sub: '三档方案灵活选择，满足不同需求与预算',
  full_plan_note_title: '费用说明与包含项目',
  full_plan_note_inc_title: '费用通常包含：',
  full_plan_note_extra_title: '可能额外费用：',
  full_plan_note_footer: '* 以上为参考区间，实际费用因方案选择、个人医疗情况及币率变动而有所差异。请联系我们的医疗顾问获取针对您的精确报价。无忧方案无限促排有限期为1年，自第一次取卵之日起计算。',
  full_plan_economy_item1: '一次促排取卵',
  full_plan_economy_item2: 'ICSI单精子注射',
  full_plan_economy_item3: '全部胚胎培养5-7天',
  full_plan_economy_item4: 'PGT-A筛查（单次8颗）',
  full_plan_economy_item5: '单周期内一次移植',
  full_plan_economy_item6: '助孕志愿者筛选与检查',
  full_plan_economy_item7: '孕期全程监护',
  full_plan_economy_item8: '持牌妇产医院顺产',
  full_plan_economy_item9: '出生证明+回国手续',
  full_plan_economy_item10: '1年期胚胎冷冻保存',
  full_plan_premium_item1: '包含惠享方案全部内容',
  full_plan_premium_item2: '单周期内不限次移植',
  full_plan_premium_item3: '志愿者孕期风险补偿',
  full_plan_premium_item4: '生产过程专属陪同',
  full_plan_premium_item5: '全程孕检报告解读',
  full_plan_premium_item6: 'DNA亲子鉴定协助',
  full_plan_premium_item7: '新生儿回国签证协助',
  full_plan_premium_item8: '付款节点更分散',
  full_plan_premium_item9: 'VIP医疗顾问服务',
  full_plan_premium_item10: '紧急医疗预案保障',
  full_plan_comp_item1: '包含安心方案全部内容',
  full_plan_comp_item2: '不限次促排取卵',
  full_plan_comp_item3: '不限次胚胎移植',
  full_plan_comp_item4: '多周期PGT-A筛查',
  full_plan_comp_item5: '含前两次周期用药',
  full_plan_comp_item6: '多周期胚胎冷冻',
  full_plan_comp_item7: '志愿者意外险保障',
  full_plan_comp_item8: '专业翻译全程陪同',
  full_plan_comp_item9: '无限促排1年有效期',
  full_plan_comp_item10: '最高成功率保障',
  full_plan_note_inc_item1: '医生诊费及方案制定',
  full_plan_note_inc_item2: '促排药物费用（吉国）',
  full_plan_note_inc_item3: '取卵手术及麻醉费',
  full_plan_note_inc_item4: 'ICSI实验室费用',
  full_plan_note_inc_item5: '胚胎培养及PGT-A筛查',
  full_plan_note_inc_item6: '胚胎移植手术费',
  full_plan_note_inc_item7: '志愿者筛选管理费',
  full_plan_note_inc_item8: '孕期医疗监护费',
  full_plan_note_inc_item9: '顺产费用及新生儿护理',
  full_plan_note_inc_item10: '回国手续法律文件',
  full_plan_note_extra_item1: '委托方赴吉国机票及住宿费',
  full_plan_note_extra_item2: '中国护照申请及户籍登记费',
  full_plan_note_extra_item3: '国内促排药物及监测费',
  full_plan_note_extra_item4: 'PGT-M基因筛查（可选）',
  full_plan_note_extra_item5: '额外胚胎PGT-A筛查',
  full_plan_note_extra_item6: '双胎妊娠额外补偿',
  full_plan_note_extra_item7: '剖腹产额外补偿',
  full_plan_note_extra_item8: '保姆育儿嫂费用',

  // Common
  read_more: '阅读更多',
  back: '返回',
  loading: '加载中...',
  submit: '提交',
  close: '关闭',
  home: '首页',
  retry: '重试',
};

export default common;